module.exports = __webpack_public_path__ + "static/media/7-Suarez(1).47e731a1.png";